import { FC } from "react";
import {
  PreviewCard,
  PreviewLabel,
  PreviewRoot,
  PreviewSwatch,
  PreviewSwatches,
} from "./ThemePreview.styles";

export interface ThemePreviewProps {
  label: string;
  colors: Array<string | null>;
  htmlFor?: string;
  checked?: boolean;
}

export const ThemePreview: FC<ThemePreviewProps> = ({
  label,
  colors,
  htmlFor,
  checked = false,
}) => {
  return (
    <PreviewRoot htmlFor={htmlFor}>
      <PreviewCard $checked={checked}>
        <PreviewSwatches aria-hidden="true">
          {colors.map((color, index) => (
            <PreviewSwatch key={`${label}-${index}`} $color={color} $isPlaceholder={!color} />
          ))}
        </PreviewSwatches>
        <PreviewLabel>{label}</PreviewLabel>
      </PreviewCard>
    </PreviewRoot>
  );
};
